import { Platform } from '@ionic/angular'
import { CapacitorHttpService } from '@core/services/cap-http/cap-http.service'
import { NgHttpService } from '@core/services'
import { inject } from '@angular/core'

export const httpFactory = () => {
  const platform = inject(Platform)
  return platform.is('ios') ? new CapacitorHttpService() : inject(NgHttpService)
}
